import axios from 'axios'
import store from '../../store/index'

const state = {
  company: {},
}

const mutations = {
  company_data (state, company) {
    state.company = company
  },
}

const actions = {
  companyUpdate ({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/company',
        data: company,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('company_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  companyRequest ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/company',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('company_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
